import { render, staticRenderFns } from "./digital.vue?vue&type=template&id=704d4d1a&scoped=true"
import script from "./digital.vue?vue&type=script&lang=js"
export * from "./digital.vue?vue&type=script&lang=js"
import style0 from "./digital.vue?vue&type=style&index=0&id=704d4d1a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704d4d1a",
  null
  
)

export default component.exports